import { Instance } from 'mobx-state-tree';
import { ShouldReoptimizeScenarioDtoModelBase } from './ShouldReoptimizeScenarioDtoModel.base';

/* The TypeScript type of an instance of ShouldReoptimizeScenarioDtoModel */
export interface ShouldReoptimizeScenarioDtoModelType extends Instance<typeof ShouldReoptimizeScenarioDtoModel.Type> {}

/* A graphql query fragment builders for ShouldReoptimizeScenarioDtoModel */
export {
  selectFromShouldReoptimizeScenarioDto,
  shouldReoptimizeScenarioDtoModelPrimitives,
  ShouldReoptimizeScenarioDtoModelSelector,
} from './ShouldReoptimizeScenarioDtoModel.base';

/**
 * ShouldReoptimizeScenarioDtoModel
 */
export const ShouldReoptimizeScenarioDtoModel = ShouldReoptimizeScenarioDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
